// Systems.tsx
import React, {  } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import AccordionPanel from "../components/system/AccordionPanel";
import ConfigDetails from "../components/system/ConfigDetails";
import SystemDetails from "../components/system/SystemDetails";
import SystemSettingsForm from "../components/system/forms/SystemSettingsForm";
import { useSystemsManager } from "../hooks/systems/useSystemsManager";
import { SystemsContext, useSystemsContext } from "../context/SystemsContext";
import SystemActionButtons from "../components/system/SystemActionButtons";
import SavingModal from "../components/system/SavingModal";

// This new component decides which main view to show
const MainContentPanel: React.FC = () => {
  const { isLoadingSystem, selectedSection, expandedConfigId, configs } = useSystemsContext();
  const selectedConfig = configs.find((c: any) => c.clientProcess?.name === expandedConfigId);
  const configSectionData = selectedConfig?.[selectedSection || ""];

  if (isLoadingSystem) {
    return (
      <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress size={60} />
      </Box>
    );
  }
  if (selectedSection === "createSystem") {
    return <SystemSettingsForm />;
  }
  if (selectedSection === "systemInfo") {
    return <SystemDetails />;
  }
  if (configSectionData) {
    return <ConfigDetails />;
  }
  return <Typography variant="body1" sx={{ mt: 4 }}>Select a section to view details</Typography>;
};

const Systems: React.FC = () => {
  const systemsManager = useSystemsManager();

  return (
    <SystemsContext.Provider value={systemsManager}>
      <Box sx={{ display: "flex", height: "calc(100vh - 64px)", overflow: "hidden" }}>
        {/* AccordionPanel will now use the context internally, no props needed! */}
        <AccordionPanel />

        {/* The right panel is now clean */}
        <Box sx={{ flex: 1, p: 3, overflow: "auto" }}>
          <MainContentPanel />
          <SystemActionButtons />
        </Box>
        
        {/* The saving modal is also a clean, self-contained component */}
        <SavingModal />
      </Box>
    </SystemsContext.Provider>
  );
};



export default Systems;
